export const L10N = {
  CAPTION: { id: 'common.label.required_field', defaultMessage: '　' },
};
